/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { OnDestroy } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SystemUser } from '@tamalelibs/models/user.model';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { ContactViewModel } from '@tamalelibs/components/contact.view-model';
import { DialogAction } from '../../../widgets/tam-dialog/tam-dialog.model';
import { ContactDialogSectionName } from '../../contact-detail-new/contact-body-detail.model';
import { ContactTemplateType, NavigationAction } from '../../contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../../contact-dialog-new/contact-template.service';
import { NavigationMenu } from '../../navigation-menu/navigation-menu.model';
import { TemplateSettingDialogService } from '../../template-setting-dialog/template-setting-dialog.service';

@Component({
    selector: 'tam-contact-navigation-bar',
    templateUrl: './contact-navigation-bar.component.html',
    styleUrls: ['./contact-navigation-bar.component.scss'],
    standalone: false
})
export class ContactNavigationBarComponent implements OnInit, OnDestroy {
    @Input() config: any;
    navigationMenuContainer: Array<NavigationMenu> = [];
    selectedIndex = 0;
    isPPCUser = false;
    isShowConfig = false;
    private _destroySubscriptions: Array<Subscription> = [];
    private _iconArray = [];
    private _currentUser: SystemUser;
    constructor(
        private _contactTemplateService: ContactTemplateService,
        private _contactViewModel: ContactViewModel,
        private _templateSettingDialogService: TemplateSettingDialogService,
        private _storeQuerier: StoreQuerierService,
    ) { }

    ngOnInit() {
        this._init();
        this._destroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(res => {
                if (res.type === NavigationAction.ChangeNavigationSection) {
                    this.selectedIndex = this.navigationMenuContainer.findIndex(item => item.type === res.payload.name);
                }
            }),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    itemOnClick($event, menu, index) {
        this.selectedIndex = index;
        this._contactTemplateService.actionSubject$.next({
            type: NavigationAction.ChangeDialogSection,
            payload: {
                name: menu.type,
                instanceId: this.config.dialogOpenOptions.instanceId
            }
        });
    }

    trackByFn(index, item) {
        return item.id;
    }

    /**
     * PPC User setting contact template
     *
     * @param {*} event
     * @memberof ContactNavigationBarComponent
     */
    clickSetting(event) {
        this._templateSettingDialogService.dialogOpen$.next(null);
        this._contactTemplateService.actionSubject$.next({
            type: DialogAction.CloseDialog,
            payload: {
                instanceId: this.config.dialogOpenOptions.instanceId
            }
        });
    }

    private _init() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        // PPC user can save
        this.isPPCUser = this._currentUser.credential.publishPubConfiguration;
        const options = this.config.dialogOpenOptions;
        if (options.openType === ContactTemplateType.NewContact
            && options.instanceId === '' && this.isPPCUser && !options.isBlastEmail && !options.contact) {
            this.isShowConfig = true;
        } else {
            this.isShowConfig = false;
        }
        this._iconArray = [
            { id: ContactDialogSectionName.BasicInformation, name: 'contact-basic-info', tid: 'basic_information' },
            { id: ContactDialogSectionName.ContactInformation, name: 'contact-contact-info', tid: 'contact_information' },
            { id: ContactDialogSectionName.Address, name: 'contact-address', tid: 'address' },
            { id: ContactDialogSectionName.Employment, name: 'contact-employment', tid: 'employment' },
            { id: ContactDialogSectionName.Relationship, name: 'contact-relationship', tid: 'relationships' },
            { id: ContactDialogSectionName.Internet, name: 'contact-social-media', tid: 'internet_information' },
            { id: ContactDialogSectionName.Other, name: 'contact-others', tid: 'others' },
            { id: ContactDialogSectionName.Note, name: 'contact-notes', tid: 'notes' },
        ];
        if (this.config) {
            this.config.contains.forEach(element => {
                this._iconArray.forEach((el, index) => {
                    if (el.id === element.sectionName && !element.isHidden) {
                        this.navigationMenuContainer.push(
                            new NavigationMenu(index.toString(), el.id, element.sectionId, { name: el.name }, null, null, el.tid)
                        );
                    }
                });
            });
        }
    }
}
